import requester from './requester';
import {
  COPY_APPLICATION_LINK,
  CREATE_PERMISSION_REQUEST,
  CREATE_PROPERTY,
  DECLINE_APPLICATION,
  FETCH_APPLICANTS_DATA_ENDPOINT,
  FETCH_ID_VERIFICATION_STATUS_ENDPOINT,
  FETCH_LISTING_APPLICATIONS_ENDPOINT,
  FETCH_ONBOARDING_PAGE_VIEWED,
  GET_APPLICATION_PERMISSIONS,
  GET_APPLICATIONS_BROWNOUT_WARNING_MESSAGE_ENDPOINT,
  GET_DECLINE_REASONS,
  GET_LEAD_DETAILS,
  GET_NAMES,
  GET_PROPERTY_ANALYTICS,
  GET_PROPERTY_DETAILS,
  GET_SPLIT_AB_TREATMENT,
  GET_TERM_SET,
  GET_USER,
  MARK_RENTAL_TERMS_ACCEPTED_ENDPOINT,
  REQUEST_APPLICATION_MANAGER_ID_VERIFICATION,
  RETRIEVE_SHARED_REPORTS,
  SEND_INVITATION,
  SET_ENROLLMENT_STATUS,
  SET_NAME,
  UPDATE_APPLICATION_VIEWED_BY_IRENE,
  UPDATE_ONBOARDING_PAGE_VIEWED,
} from '../constants/endpoints';

const api = {
  user: {
    info(params) {
      return requester({
        method: 'get',
        path: GET_USER,
        params,
      });
    },
    properties: {
      details(params) {
        return requester({
          method: 'get',
          path: GET_PROPERTY_DETAILS,
          params,
        });
      },
    },
  },
};

export const getApplicationPermissionsApi = (params) => {
  return requester({
    method: 'GET',
    path: GET_APPLICATION_PERMISSIONS,
    params,
  });
};

export const fetchListingApplicationsDataApi = (params) => {
  return requester({
    method: 'GET',
    path: FETCH_LISTING_APPLICATIONS_ENDPOINT,
    params,
  });
};

export const fetchApplicantsDataApi = (params) => {
  return requester({
    method: 'GET',
    path: FETCH_APPLICANTS_DATA_ENDPOINT,
    params,
  });
};

export const fetchIdVerificationStatusApi = (params) => {
  return requester({
    method: 'GET',
    path: FETCH_ID_VERIFICATION_STATUS_ENDPOINT,
    params,
  });
};

export const getTermSetApi = (params) => {
  return requester({
    method: 'GET',
    path: GET_TERM_SET,
    params,
  });
};

export const updateIsOnboardingPageViewedApi = (data) => {
  return requester({
    method: 'POST',
    path: UPDATE_ONBOARDING_PAGE_VIEWED,
    body: data,
  });
};

export const fetchIsOnboardingPageViewedApi = (params) => {
  return requester({
    method: 'GET',
    path: FETCH_ONBOARDING_PAGE_VIEWED,
    params,
  });
};

export const sendInvitationApi = (data) => {
  return requester({
    method: 'POST',
    path: SEND_INVITATION,
    body: data,
  });
};

export const copyApplicationLinkApi = (data) => {
  return requester({
    method: 'POST',
    path: COPY_APPLICATION_LINK,
    body: data,
  });
};

export const setEnrollmentStatusApi = (params) => {
  return requester({
    method: 'GET',
    path: SET_ENROLLMENT_STATUS,
    params,
  });
};

export const getListingDetailsApi = api.user.properties.details;

export const logFirstTimeViewingApi = (params) => {
  return requester({
    method: 'GET',
    path: UPDATE_APPLICATION_VIEWED_BY_IRENE,
    params: {
      ...params,
      requestingClient: 'ra-landlord-web-ssr.applicationViewedByIrene',
    },
  });
};

export const processDataWrap = (data) => {
  if (data && data.response && data.response.data) {
    return data.response.data;
  }

  return data;
};

export const markRentalTermsAcceptedApi = (data) => {
  return requester({
    method: 'POST',
    path: MARK_RENTAL_TERMS_ACCEPTED_ENDPOINT,
    body: data,
  });
};

export const retrieveSharedReportsApi = (params) => {
  return requester({
    method: 'GET',
    path: RETRIEVE_SHARED_REPORTS,
    params,
  });
};

export const getApplicationsBrownoutWarningMessageApi = () => {
  return requester({
    method: 'GET',
    path: GET_APPLICATIONS_BROWNOUT_WARNING_MESSAGE_ENDPOINT,
  });
};

export const getLeadDetails = (params) => {
  return requester({
    method: 'GET',
    path: GET_LEAD_DETAILS,
    params,
  });
};

export const requestApplicationManagerIdVerification = () => {
  return requester({
    method: 'GET',
    path: REQUEST_APPLICATION_MANAGER_ID_VERIFICATION,
  });
};

export const createPermissionRequest = (params) => {
  return requester({
    method: 'GET',
    path: CREATE_PERMISSION_REQUEST,
    params,
  });
};

export const declineApplication = (requestBody) => {
  return requester({
    method: 'POST',
    path: DECLINE_APPLICATION,
    body: requestBody,
  });
};

export const getDeclineReasons = () => {
  return requester({
    method: 'GET',
    path: GET_DECLINE_REASONS,
  });
};

export const getPropertyAnalytics = (params) => {
  return requester({
    method: 'GET',
    path: GET_PROPERTY_ANALYTICS,
    params,
  });
};

export const setName = (params) => {
  return requester({
    method: 'GET',
    path: SET_NAME,
    params,
  });
};

export const getNames = (body) => {
  return requester({
    method: 'POST',
    path: GET_NAMES,
    body,
  });
};

export const createProperty = (params) => {
  return requester({
    method: 'GET',
    path: CREATE_PROPERTY,
    params: {
      ...params,
      unit: params.unit ? encodeURIComponent(params.unit) : undefined,
    },
    skipAuthValidation: true,
  });
};

export const getSplitAbTreatment = (params) => {
  return requester({
    method: 'GET',
    path: GET_SPLIT_AB_TREATMENT,
    params,
  });
};

export default api;
